import { Alert, Button, Modal, notification } from 'antd'
import { isEmpty, isObject, omit } from 'lodash'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { styled } from 'styled-components'
import { getCorrectFieldName, handleBackendError } from '../../utils'

const FieldGroup = styled.div`
  margin: 20px 0;
`

const Label = styled.div`
  margin: 3px 0;

  font-weight: bold;
`

const FieldValue = styled.div`
  margin: 3px 0;

  text-transform: capitalize;
`

export const InfoModal = ({
  apiRequest,
  errorMessage,
  hideModal,
  isEmbedded = false,
  selectedId,
  title,
}) => {
  const [data, setData] = useState({})

  useEffect(() => {
    apiRequest(selectedId)
      .then(({ data }) => setData(omit(data, ['full_address'])))
      .catch((error) => {
        notification.error({
          description: handleBackendError(error, 'Fetching data failed!'),
          duration: 3,
          title: 'Error',
        })

        hideModal()
      })
  }, [selectedId])

  const RenderedContent = () =>
    Object.keys(data).map((key) => (
      <FieldGroup key={key} name={key}>
        <Label>{getCorrectFieldName(key)}</Label>
        {isObject(data[key]) ? (
          Object.keys(data[key]).map((objectKey) => (
            <FieldGroup key={objectKey} name={objectKey}>
              <Label>{getCorrectFieldName(objectKey)}</Label>
              <FieldValue>{data[key][objectKey]}</FieldValue>
            </FieldGroup>
          ))
        ) : (
          <FieldValue>{data[key]}</FieldValue>
        )}
      </FieldGroup>
    ))

  if (isEmpty(data)) return null

  if (isEmbedded) {
    return (
      <div>
        <RenderedContent />
      </div>
    )
  } else {
    return (
      <Modal
        footer={[<Button key="cancel" onClick={hideModal} type="primary">Cancel</Button>]}
        onCancel={hideModal}
        open
        title={title}
      >
        <div>
          <RenderedContent />
        </div>

        {errorMessage && (
          <Alert description={errorMessage} showIcon style={{ marginTop: 20 }} title="Error" type="error" />
        )}
      </Modal>
    )
  }
}

InfoModal.propTypes = {
  apiRequest: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  hideModal: PropTypes.func.isRequired,
  isEmbedded: PropTypes.bool,
  selectedId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default InfoModal
